var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 41",
    style: {
      enableBackground: "new 0 0 22 41"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9,6.3C8.7,6,8.2,5.7,7.7,5.7c-0.5,0-1.1,0.2-1.5,0.6C5.9,6.6,5.6,7.1,5.6,7.6c0,0.5,0.2,1.1,0.6,1.5 c3,3.1,4.6,7.1,4.6,11.4c0,4.3-1.6,8.3-4.6,11.4c-0.8,0.8-0.8,2,0,2.8c0.4,0.4,0.9,0.6,1.4,0.6c0,0,0,0,0.1,0c0.5,0,1-0.2,1.3-0.6 c3.7-3.7,5.9-8.9,5.9-14.2C14.8,15.3,12.8,10.2,9,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.2,11L4.2,11c-0.8-0.8-2.1-0.9-2.9-0.1c-0.8,0.8-0.8,1.9-0.1,2.7c1.7,1.8,2.6,4.2,2.6,6.7c0,2.5-0.9,4.9-2.6,6.7 c-0.7,0.8-0.6,2.1,0.1,2.7c0.4,0.4,0.9,0.6,1.4,0.6c0,0,0,0,0.1,0c0.5,0,1-0.3,1.4-0.7C6.6,27.3,8,23.9,8,20.4 C8,16.9,6.6,13.6,4.2,11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.9,1.5c-0.3-0.4-0.8-0.6-1.3-0.6c-0.6,0-1.1,0.2-1.5,0.6c-0.7,0.7-0.8,1.9,0,2.8c4.3,4.3,6.7,10.1,6.7,16.2 c0,6-2.4,11.8-6.7,16.2c-0.8,0.8-0.8,2,0,2.8c0.4,0.4,0.9,0.6,1.4,0.6c0,0,0,0,0.1,0c0.5,0,1-0.2,1.3-0.6c5.1-5.2,7.9-11.9,7.9-19 C21.8,13.4,19,6.7,13.9,1.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.da322b705e1cdae85b1c9bb3f8c98294.svg";
export { ForwardRef as ReactComponent };